import * as React from 'react';
import * as styles from './InstagramCard.css';

interface IInstagramCardProps {
  media: React.ReactNode;
  avatar: React.ReactNode;
  userName: React.ReactNode;
}

export function InstagramCard({ media, avatar, userName }: IInstagramCardProps) {
  return (
    <article className={styles['card']}>
      <div className={styles['card__media']}>{media}</div>

      <div className={styles['card__description']}>
        <div className={styles['card__avatar']}>{avatar}</div>

        {userName}
      </div>
    </article>
  );
}
